import React from "react";
import {Button, Card, CardContent, Grid} from "@material-ui/core";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonCard = (props: any) => {

    return (
      <>
        <Card variant="outlined" className="basic_card skeleton_card ">
          <CardContent>
            {/*----Title Start----*/}
            <div className="title_row">
              <h2>
                <Skeleton width={170} />
              </h2>
              {props?.hasEdit && props?.canEdit && (
                <div className="action_icon">
                  <Skeleton/>
                </div>
              )}
              <div className="clearfix" />
            </div>
            {/*----Title End----*/}

            {/*----Information Start----*/}
            <div className="info_detail">
              <Grid container>
                <Grid className="" item xs={12}>
                  <div className="tb_info_section mt-13">
                    {/*--- Display repeating based on value ---*/}
                    {Array(props?.numOfRows)
                      .fill(0)
                      .map((index) => (
                      <Grid container className="row" key={index}>
                      {props?.rowHeader && (
                        <Grid>
                        <h2>
                          <Skeleton width={500} />
                        </h2>
                        </Grid>
                      )}
                      {Array(props?.numOfColumns)
                      .fill(0)
                      .map((index) => (
                           <Skeleton width={props?.width || 130} key={index} className="mr-40 mb-20"/>
                      ))}
                      </Grid>
                      ))}
                    {props?.hasMap && (
                      <div className="info_detail">
                        <div className="station_route_map">
                          <div style={{height: "100%", width: "100%"}}>
                            <Skeleton height={props?.mapHeight ? props?.mapHeight : 960} />
                          </div>
                        </div>
                      </div>
                    )}
                    {props?.hasButton && (
                      <div className="button_row">
                        <Grid container direction="row" alignItems="center" spacing={0}>
                          <Grid className="text_left" item xs={12}>
                            <Button>
                              <Skeleton height={50} width={100} />
                            </Button>
                          </Grid>
                        </Grid>
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
            </div>
            {/*----Information End----*/}
          </CardContent>
        </Card>
      </>
    );
}

export default SkeletonCard;